<template>
  <v-dialog persistent v-model="dialogVisible" max-width="350px">
    <template #activator="{ on }">
      <v-btn v-bind="attrs" v-on="on" color="primary">
        Add to Balance
      </v-btn>
    </template>

    <v-card>
      <v-card-title style="background-color: #004056" class="white--text">
        <span class="text-h5">Add to Balance?</span>
      </v-card-title>

      <v-divider class="mb-2"/>

      <v-card-text class="mt-4">
        Yes I want to add {{ formatCurrency(amount) }} to my balance.
      </v-card-text>

      <v-divider />

      <v-card-actions class="justify-center py-3">
        <v-btn @click="close">Cancel</v-btn>
        <v-btn color="primary" @click="onConfirm">Confirm</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>      
 
<script>

import formatters from '@/lib/formatters'

export default {
  name: 'AddToBalanceConfirmDialog',

  inheritAttrs: false, // <- added just for safety

  props: ['value', 'amount'],

  data: () => ({
    dialogVisible: false,
  }),

  computed: {
    attrs() {
      const attrs = { ...this.$attrs }

      // adding class and style for `v-bind`
      attrs.class = this.$vnode.data.staticClass
      attrs.style = this.$vnode.data.staticStyle
            
      return attrs
    },
  },
  
  methods: {
    ...formatters,

    close() {
      this.dialogVisible = false
    },

    onConfirm() {
      this.$emit('confirm')
      this.close()
    },
  },
};
</script>